module.exports = __webpack_public_path__ + "img/11.82d25d70.jpg";